import trim from 'lodash/trim';

export default value => trim(value);
